module.exports = __webpack_public_path__ + "static/media/university.7cf7a21c.jpg";